export const useIsCircleAIIntroEligible = () => false; // Disable it for now until we get the confirmation from the team
